import React from 'react';
import { useTranslation } from 'react-i18next';
import navbarLogo from '../../assets/logo/navbar-logo.png';
import './footer.scss';

const Footer = () => {
  const [t] = useTranslation('global');
  const currentYear = new Date().getFullYear();

  return (
    <footer className="globalFooter">
      <div className="footerContent">
        <div className="footerBrand">
          <img
            src={navbarLogo}
            alt="Laura Candela"
            className="footerTicketLogo"
            loading="lazy"
          />
        </div>

        <div className="footerLinks">
          <a
            href="https://resumes.actorsaccess.com/laura-candela"
            target="_blank"
            rel="noopener noreferrer"
            className="footerLink"
          >
            Actors Access
          </a>
          <span className="footerSeparator">·</span>
          <a
            href="https://app.castingnetworks.com/talent/public-profile/lauracandela"
            target="_blank"
            rel="noopener noreferrer"
            className="footerLink"
          >
            Casting Networks
          </a>
          <span className="footerSeparator">·</span>
          <a
            href="https://www.imdb.com/name/nm8379596/"
            target="_blank"
            rel="noopener noreferrer"
            className="footerLink"
          >
            IMDb
          </a>
          <span className="footerSeparator">·</span>
          <a
            href="https://www.instagram.com/lauracandelaactriz/"
            target="_blank"
            rel="noopener noreferrer"
            className="footerLink"
          >
            Instagram
          </a>
          <span className="footerSeparator">·</span>
          <a
            href="https://brossontalent.com/D/product/laura-candela/"
            target="_blank"
            rel="noopener noreferrer"
            className="footerLink"
          >
            Brosson Talent
          </a>
          <span className="footerSeparator">·</span>
          <a
            href="https://www.edav.es/es/guionistes/sales-candela-laura/"
            target="_blank"
            rel="noopener noreferrer"
            className="footerLink"
          >
            EDAV
          </a>
        </div>

        <p className="footerCopyright">
          © {currentYear} Laura Candela. {t('ShortBrief')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;